
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { 
  Building2, 
  Users, 
  Clock, 
  Music, 
  Instagram, 
  Facebook, 
  Globe,
  Edit
} from "lucide-react";

export const ClubProfilePage = () => {
  const demoProfile = {
    name: "Skyline Lounge",
    coverPhoto: "https://images.unsplash.com/photo-1566737236500-c8ac43014a67?auto=format&fit=crop&q=80",
    logo: "https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?auto=format&fit=crop&q=80",
    shortDescription: "Premium rooftop venue with panoramic city views",
    capacity: 500,
    address: "123 Downtown Ave, City Center",
    operatingHours: {
      "Friday": "8:00 PM - 4:00 AM",
      "Saturday": "8:00 PM - 4:00 AM",
      "Sunday": "6:00 PM - 2:00 AM"
    },
    musicGenres: ["House", "Techno", "Deep House"],
    vibeTags: ["Rooftop", "Upscale", "View"],
    socialMedia: {
      instagram: "@skylinelounge",
      facebook: "SkylineLoungeOfficial"
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Venue Profile</h1>
        <Button variant="outline">
          <Edit className="mr-2 h-4 w-4" />
          Edit Profile
        </Button>
      </div>

      <div className="relative h-64 rounded-xl overflow-hidden">
        <img 
          src={demoProfile.coverPhoto} 
          alt="Cover" 
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-4 left-4 flex items-center gap-4">
          <img 
            src={demoProfile.logo} 
            alt="Logo" 
            className="w-20 h-20 rounded-full border-4 border-white"
          />
          <div>
            <h2 className="text-2xl font-bold text-white">{demoProfile.name}</h2>
            <p className="text-white/90">{demoProfile.shortDescription}</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Venue Details</h3>
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <Building2 className="h-5 w-5 text-muted-foreground" />
              <span>{demoProfile.address}</span>
            </div>
            <div className="flex items-center gap-3">
              <Users className="h-5 w-5 text-muted-foreground" />
              <span>Capacity: {demoProfile.capacity}</span>
            </div>
            <div className="flex items-center gap-3">
              <Clock className="h-5 w-5 text-muted-foreground" />
              <div className="space-y-1">
                {Object.entries(demoProfile.operatingHours).map(([day, hours]) => (
                  <div key={day}>
                    <span className="font-medium">{day}:</span> {hours}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Music & Vibe</h3>
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <Music className="h-5 w-5 text-muted-foreground" />
              <div className="flex flex-wrap gap-2">
                {demoProfile.musicGenres.map(genre => (
                  <Badge key={genre} variant="secondary">{genre}</Badge>
                ))}
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {demoProfile.vibeTags.map(tag => (
                <Badge key={tag} variant="outline">{tag}</Badge>
              ))}
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Online Presence</h3>
          <div className="space-y-4">
            <Button variant="outline" className="w-full justify-start">
              <Instagram className="mr-2 h-4 w-4" />
              {demoProfile.socialMedia.instagram}
            </Button>
            <Button variant="outline" className="w-full justify-start">
              <Facebook className="mr-2 h-4 w-4" />
              {demoProfile.socialMedia.facebook}
            </Button>
            <Button variant="outline" className="w-full justify-start">
              <Globe className="mr-2 h-4 w-4" />
              Visit Website
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};
